module.exports = __webpack_public_path__ + "img/ic_point_1.e5f1abd5.svg";